import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const ShippingTemperature = ({ shippingTemperature, handleChange, pullLists, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.BIOOPS, ROLES.APPROVER]);

    return (
        <div className="planField">
            <GroupBDRBiologists />
            <FormControl required={required}>
                <FormLabel className="planRadioTitle">
                    {pullListLabels.shippingTemperature}
                </FormLabel>
                <RadioGroup
                    id="shippingTemperature-field"
                    name="shippingTemperature"
                    label={pullListLabels.shippingTemperature}
                    value={shippingTemperature}
                    onChange={(e) => handleChange("shippingTemperature", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Ambient"
                        control={<Radio disabled={!canEdit} />}
                        label="Ambient"
                    />
                    <FormControlLabel
                        value="Refrigerated with Gel Packs"
                        control={<Radio disabled={!canEdit} />}
                        label="Refrigerated with Gel Packs"
                    />
                    <FormControlLabel
                        value="Dry Ice"
                        control={<Radio disabled={!canEdit} />}
                        label="Dry Ice"
                    />
                    <FormControlLabel
                        value="LN2 Dewar"
                        control={<Radio disabled={!canEdit} />}
                        label="LN2 Dewar"
                    />
                </RadioGroup>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"shippingTemperature"} />
        </div>
    );
};

export default ShippingTemperature;